<template>
  <Nonberusaha :tipe_pemohon="'Swasta'" />
</template>

<script>
import Nonberusaha from './Nonberusaha.vue'

export default {
  components: { Nonberusaha },
}
</script>
